import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Doc = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M10.6004 6.5C9.72226 6.5 9.00037 7.21766 9.00037 8.11538V31.8846C9.00037 32.7823 9.72226 33.5 10.6004 33.5H29.4C30.2781 33.5 31 32.7823 31 31.8846V15H25.0004C23.3435 15 22.0004 13.6569 22.0004 12V6.5H10.6004ZM24.0004 7.82001L29.4848 13H25.0004C24.4481 13 24.0004 12.5523 24.0004 12V7.82001ZM7.00037 8.11538C7.00037 6.12423 8.60659 4.5 10.6004 4.5H23.398L33 13.569V31.8846C33 33.8758 31.3937 35.5 29.4 35.5H10.6004C8.60659 35.5 7.00037 33.8758 7.00037 31.8846V8.11538ZM12.0004 19.0769C12.0004 18.5246 12.4481 18.0769 13.0004 18.0769H19.0004C19.5527 18.0769 20.0004 18.5246 20.0004 19.0769C20.0004 19.6292 19.5527 20.0769 19.0004 20.0769H13.0004C12.4481 20.0769 12.0004 19.6292 12.0004 19.0769ZM12.0004 24.9923C12.0046 24.44 12.4558 23.9958 13.0081 24L23.0081 24.077C23.5603 24.0812 24.0046 24.5324 24.0003 25.0846C23.9961 25.6369 23.5449 26.0812 22.9927 26.0769L12.9927 26C12.4404 25.9957 11.9961 25.5446 12.0004 24.9923Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Doc;
